// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eSsX","top":"styles_top__34aiZ","left":"styles_left__Bk6Jc","description":"styles_description__3M6P2"};